import { defineMeta } from '@/registry/types';

export const dateRangePickerMeta = defineMeta({
  name: 'DateRangePicker',
  level: 'molecule',
  category: 'input',
  classification: 'custom',
  description:
    'Start/end date range picker wrapping rsuite DateRangePicker (same control as the app), with canonical presets, a time panel + Now/AM-PM, dayjs-friendly presets and valueType conversion. Presets sit in a left rail; the footer shows an Apply button (left) with the selected range (right). Times default to 12:00:00 AM–11:59:59 PM, so selecting the same day twice covers the full day automatically.',
  baseLibrary: 'custom',
  muiEquivalent: 'rsuite DateRangePicker (wrapped)',
  muiDocs: 'https://rsuitejs.com/components/date-range-picker/',
  a2uiEquivalent: 'DateRangePicker',
  importPath: '@/molecules/DateRangePicker',
  optionalProps: [
    'value',
    'defaultValue',
    'onChange',
    'presets',
    'defaultPreset',
    'allowAllTime',
    'futureMode',
    'minDate',
    'maxDate',
    'valueType',
    'format',
    'showTime',
    'showMeridian',
    'variant',
    'disabled',
    'label',
    'placement',
  ],
  props: [
    { name: 'value', type: '{ start, end }', description: 'Controlled range in the chosen valueType' },
    { name: 'valueType', type: "'dayjs' | 'date' | 'string'", default: "'dayjs'" },
    { name: 'format', type: 'string (date-fns tokens)', default: "'MMM d, yyyy'" },
    { name: 'showTime', type: 'boolean', default: 'true' },
    { name: 'showMeridian', type: 'boolean', default: 'true' },
    { name: 'variant', type: "'standalone' | 'embedded'", default: "'standalone'" },
  ],
  customVariants: ['standalone', 'embedded'],
  supportedStates: ['default', 'open', 'disabled'],
  designTokens: ['colors', 'radius', 'spacing'],
  accessibility: [
    'Trigger exposes an aria-label; calendars are keyboard operable.',
    'Provide a `label` when there is no adjacent visible label.',
  ],
  usageExamples: [
    '<DateRangePicker value={range} onChange={setRange} allowAllTime />',
    '<DateRangePicker variant="embedded" valueType="string" format="YYYY-MM-DD" />',
  ],
  antiPatterns: [
    'Do not use for a single date (use DatePicker).',
    'Do not mix value types across reads/writes; set one `valueType`.',
  ],
  llmSafe: true,
  whenToUse: ['Filtering by a time window', 'Report/date-range editors'],
  whenNotToUse: ['A single calendar date (use DatePicker)', 'Times only (use TimePicker)'],
});

export default dateRangePickerMeta;
